export default "__VITE_ASSET__ddea5454__"